// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qAag","questions":"styles_questions__2JsE4","footer":"styles_footer__22x-j"};